import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
    //список адресов организации
    orgGeoItems:[],
    partnerTypes:[]


  },
  actions,
  mutations,
  getters
}
